import React, { Component } from 'react';
import logo from '../../assets/img/VM_logo.svg';
import Settings from '../../services/settings.service';
import Storage from '../../services/storage.service';
// import Translation from '../../services/translation.service';
import User from '../../services/user.service';
import DownloadMenuButton from './download-menu-button.component';
import checkModule from './checkModule';
// import Helpers from '../../helpers/shared.helper';

class HeaderNavigation extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.menu !== this.props.menu;
    }

    checkStorage = () => {
        Storage.get_obsrv("flags").subscribe(data => {
            if (data?.NumberSelected === false && data?.PlanSelected === false) {
                User.clearAll()
            }
        })
    }

    // featureEnableQuickTopup = () => {
    //     return Helpers.checkEnableTopup("feature_enable_quick_topup");
    // }

    render() {
        return (
            <div className="storefront-header">
                <a
                    onClick={() => { this.checkStorage() }}
                    href={Settings.get('site_link') + this.props.activeLang + "/"}
                    className="main-logo">
                    <img src={logo} alt="" />
                </a>
                <nav>
                    <ul className="storefront-nav-list">
                        {this.props.menu}
                        {/* {this.featureEnableQuickTopup() ? <>
                            {this.props.join_now ?
                                <li className="storefront-join-now">
                                    <span onClick={this.props.loadJoinNow}>{Translation.keys['stm_header_join_now'] || "Join Now"}</span>
                                </li> :
                                <li className="storefront-join-now">
                                    <span onClick={this.props.loadTopup}>{Translation.keys['stm_header_quick_topup'] || "Quick Top-Up"}</span>
                                </li>
                            }
                        </> : ""} */}
                        {checkModule.isHeaderKw ? <DownloadMenuButton /> : null}
                        {this.props.lang}
                    </ul>
                </nav>
            </div>

        );
    }
}

export default HeaderNavigation;